import { Routes, Route } from "react-router-dom";
import Header from "./component/Header";
import { Home } from "./pages/Home";
import "./App.css";
import { Footer } from "./component/Footer";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Blogs from "./pages/Blogs";
import Gallery from "./pages/Gallery";
import BlogDetails from "./pages/BlogDetails";
import JoinCouncil from "./pages/getinvolve/JoinCouncil";
import Advocacy from "./pages/getinvolve/Advocacy";
import Volunteer from "./pages/getinvolve/Volunteer";
import Collaboration from "./pages/getinvolve/Collaboration";
import ReportIssue from "./pages/getinvolve/ReportIssue";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import JoinVolunteer from "./pages/getinvolve/JoinVolunteer";
import ScrollToTop from "./component/ScrollToTop";
import { ToastContainer } from "react-toastify";
// import GoogleForm from "./pages/formnew";
import MemberForm from "./pages/getinvolve/MemberForm";
import VideoGallery from "./pages/VideoGallery";
function App() {
  return (
    <>
      <ToastContainer />
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/events" element={<Gallery />} />
        <Route path="/videos" element={<VideoGallery />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/Get-Involved/legal-advocacy" element={<JoinCouncil />} />
        <Route
          path="/Get-Involved/advocate-for-sanatana-rights"
          element={<Advocacy />}
        />
        <Route path="/Get-Involved/volunteer-with-us" element={<Volunteer />} />
        <Route path="/Get-Involved/research" element={<Collaboration />} />
        <Route path="/Get-Involved/report" element={<ReportIssue />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/join-volunteer" element={<JoinVolunteer />} />
        <Route path="/memberform" element={<MemberForm />} />
      </Routes>
      {/* <Footer /> */}
      <ToastContainer />
    </>
  );
}

export default App;
